export const COIN = "LUSD";
export const GT = "LQTY";
export const LP = "UNI LP";
// export const LP = "ETH/LUSD LP";
